import React from "react";

const PolicyScreen = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h1 className="text-3xl font-bold text-center text-blue-600 mb-8">
            CHÍNH SÁCH QUYỀN RIÊNG TƯ - AIPrice
          </h1>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              1. Giới thiệu
            </h2>
            <p className="text-gray-600 leading-relaxed">
              AIPrice cam kết bảo vệ quyền riêng tư của bạn. Chính sách này giải
              thích cách chúng tôi thu thập, sử dụng, chia sẻ và bảo vệ thông
              tin cá nhân của bạn khi bạn sử dụng dịch vụ định giá bất động sản
              và tự động hóa nội dung của chúng tôi ("Dịch vụ").
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              2. Thông tin chúng tôi thu thập
            </h2>
            <p className="text-gray-600 mb-4">
              Chúng tôi thu thập các loại thông tin sau:
            </p>

            <h3 className="text-xl font-medium text-gray-700 mb-3">
              2.1. Thông tin bạn cung cấp trực tiếp:
            </h3>
            <div className="text-gray-600 space-y-4 mb-6">
              <p>
                <strong>Thông tin tài khoản AIPrice:</strong> Khi bạn đăng ký sử
                dụng Dịch vụ, chúng tôi có thể yêu cầu bạn cung cấp tên người
                dùng, địa chỉ email và mật khẩu (được mã hóa).
              </p>

              <p>
                <strong>Thông tin thanh toán:</strong> Nếu bạn chọn sử dụng các
                tính năng trả phí của Dịch vụ, chúng tôi sẽ thu thập thông tin
                thanh toán cần thiết, chẳng hạn như số thẻ tín dụng hoặc thông
                tin tài khoản ngân hàng và lịch sử giao dịch.
              </p>

              <p>
                <strong>Thông tin fanpage được kết nối:</strong> Để cung cấp
                Dịch vụ, chúng tôi yêu cầu bạn cấp quyền truy cập vào fanpage
                Facebook của bạn thông qua API của Facebook. Chúng tôi KHÔNG lưu
                trữ thông tin đăng nhập Facebook của bạn.
              </p>

              <p>
                <strong>Nội dung bạn cung cấp:</strong> Bao gồm văn bản, hình
                ảnh, video, liên kết và bất kỳ thông tin nào khác mà bạn cung
                cấp để Dịch vụ tạo và lên lịch đăng bài.
              </p>

              <p>
                <strong>Cài đặt tùy chỉnh cho AI:</strong> Chủ đề, giọng văn,
                hình ảnh, thời gian và các tùy chọn khác mà bạn thiết lập.
              </p>
            </div>

            <h3 className="text-xl font-medium text-gray-700 mb-3">
              2.2. Thông tin thu thập tự động:
            </h3>
            <div className="text-gray-600 space-y-4 mb-6">
              <p>
                <strong>Thông tin thiết bị:</strong> Loại thiết bị, hệ điều
                hành, ID thiết bị duy nhất, địa chỉ IP và nhà cung cấp dịch vụ
                di động.
              </p>

              <p>
                <strong>Dữ liệu nhật ký:</strong> Thời gian truy cập, các trang
                hoặc tính năng đã sử dụng, các lỗi gặp phải và hoạt động hệ
                thống khác.
              </p>

              <p>
                <strong>Cookies và công nghệ theo dõi:</strong> Sử dụng để ghi
                nhớ thông tin đăng nhập, cá nhân hóa trải nghiệm và phân tích
                lưu lượng truy cập.
              </p>

              <p>
                <strong>Thông tin tương tác trên fanpage:</strong> Thu thập
                thông tin về các tương tác (lượt thích, bình luận, chia sẻ)
                thông qua API của Facebook.
              </p>
            </div>
          </section>

          <section className="mb-8 border-l-4 border-blue-500 pl-6 bg-blue-50 py-6">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              3. Quyền Sử dụng Dữ liệu cho Mô hình Miễn phí
            </h2>
            <div className="text-gray-700 space-y-4">
              <div className="bg-yellow-100 border-l-4 border-yellow-500 p-4 mb-4">
                <p className="font-bold text-yellow-900 mb-2">⚠️ QUAN TRỌNG - Điều kiện sử dụng miễn phí:</p>
                <p className="text-gray-800">
                  Để sử dụng dịch vụ miễn phí của AIPrice, bạn phải đồng ý cho phép chúng tôi thu thập và sử dụng dữ liệu của bạn.
                  Đây là điều kiện bắt buộc để duy trì mô hình dịch vụ miễn phí.
                </p>
              </div>

              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h3 className="font-semibold text-gray-800 mb-3">3.1. Dữ liệu BDS được thu thập và sử dụng</h3>
                <p className="mb-2">Khi bạn sử dụng tính năng định giá, chúng tôi thu thập:</p>
                <ul className="list-disc pl-6 space-y-1 text-gray-700">
                  <li>Địa chỉ và thông tin vị trí bất động sản</li>
                  <li>Loại hình, diện tích, số phòng, tiện ích</li>
                  <li>Kết quả định giá từ AI</li>
                  <li>Ảnh và mô tả bất động sản (nếu có)</li>
                  <li>Lịch sử định giá của bạn</li>
                </ul>
              </div>

              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h3 className="font-semibold text-gray-800 mb-3">3.2. Mục đích sử dụng dữ liệu</h3>
                <div className="space-y-3">
                  <div className="border-l-2 border-blue-400 pl-3">
                    <p className="font-medium text-gray-800">🤖 Huấn luyện và cải thiện AI</p>
                    <p className="text-sm text-gray-600">Sử dụng dữ liệu thực tế để train mô hình định giá chính xác hơn</p>
                  </div>
                  <div className="border-l-2 border-green-400 pl-3">
                    <p className="font-medium text-gray-800">📊 Phân tích thị trường BDS</p>
                    <p className="text-sm text-gray-600">Xây dựng xu hướng giá, dự báo thị trường cho khu vực</p>
                  </div>
                  <div className="border-l-2 border-purple-400 pl-3">
                    <p className="font-medium text-gray-800">🔬 Nghiên cứu và phát triển</p>
                    <p className="text-sm text-gray-600">Tạo các tính năng mới, báo cáo thị trường, công cụ phân tích</p>
                  </div>
                  <div className="border-l-2 border-orange-400 pl-3">
                    <p className="font-medium text-gray-800">🤝 Chia sẻ dữ liệu tổng hợp</p>
                    <p className="text-sm text-gray-600">Cung cấp báo cáo thống kê (đã ẩn danh) cho đối tác, nhà đầu tư</p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h3 className="font-semibold text-gray-800 mb-3">3.3. Cam kết bảo mật và minh bạch</h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">✓</span>
                    <span>Thông tin cá nhân (tên, email, số điện thoại) được mã hóa và bảo mật tuyệt đối</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">✓</span>
                    <span>Dữ liệu chia sẻ ra bên ngoài được ẩn danh hóa hoàn toàn</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">✓</span>
                    <span>Không bán thông tin cá nhân cho bất kỳ bên thứ ba nào</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">✓</span>
                    <span>Tuân thủ các quy định bảo vệ dữ liệu cá nhân hiện hành</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h3 className="font-semibold text-gray-800 mb-3">3.4. Quyền của bạn</h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="text-blue-600 mr-2">►</span>
                    <span><strong>Xem dữ liệu:</strong> Yêu cầu xem toàn bộ dữ liệu chúng tôi lưu trữ về bạn</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 mr-2">►</span>
                    <span><strong>Xóa dữ liệu:</strong> Yêu cầu xóa thông tin cá nhân bất kỳ lúc nào</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 mr-2">►</span>
                    <span><strong>Từ chối sử dụng:</strong> Nếu không đồng ý, bạn có thể ngừng sử dụng dịch vụ</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 mr-2">►</span>
                    <span><strong>Liên hệ:</strong> Gửi yêu cầu về dữ liệu qua email support@aiprice.vn</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              4. Cách chúng tôi sử dụng thông tin
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                <strong>Cung cấp và duy trì Dịch vụ:</strong> Vận hành và duy
                trì các tính năng của AIPrice.
              </p>
              <p>
                <strong>Cải thiện và cá nhân hóa:</strong> Điều chỉnh Dịch vụ
                theo sở thích của bạn.
              </p>
              <p>
                <strong>Phân tích hiệu suất:</strong> Theo dõi và phân tích
                tương tác để cải thiện thuật toán AI.
              </p>
              <p>
                <strong>Liên lạc:</strong> Gửi thông báo về Dịch vụ và hỗ trợ kỹ
                thuật.
              </p>
              <p>
                <strong>Xử lý thanh toán:</strong> Quản lý các giao dịch và tài
                khoản của bạn.
              </p>
              <p>
                <strong>Tuân thủ pháp luật:</strong> Đáp ứng các yêu cầu pháp lý
                khi cần thiết.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              4. Cơ sở pháp lý cho việc xử lý dữ liệu
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                Chúng tôi xử lý thông tin cá nhân của bạn dựa trên các cơ sở
                pháp lý sau:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>Thực hiện hợp đồng:</strong> Xử lý thông tin của bạn
                  để thực hiện các điều khoản dịch vụ mà bạn đã đồng ý khi sử
                  dụng AIPrice.
                </li>
                <li>
                  <strong>Lợi ích hợp pháp:</strong> Chúng tôi có lợi ích hợp
                  pháp trong việc đảm bảo hoạt động hiệu quả của dịch vụ, bảo vệ
                  an ninh, cải tiến sản phẩm và tiếp thị.
                </li>
                <li>
                  <strong>Sự đồng ý:</strong> Trong một số trường hợp, chúng tôi
                  xử lý thông tin dựa trên sự đồng ý rõ ràng của bạn.
                </li>
                <li>
                  <strong>Nghĩa vụ pháp lý:</strong> Để tuân thủ các nghĩa vụ
                  pháp lý theo quy định của pháp luật.
                </li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              5. Chia sẻ và chuyển giao dữ liệu
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>Chúng tôi có thể chia sẻ thông tin của bạn với các bên sau:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>Nhà cung cấp dịch vụ:</strong> Các bên thứ ba cung cấp
                  dịch vụ cho chúng tôi (như xử lý thanh toán, lưu trữ đám mây,
                  phân tích dữ liệu).
                </li>
                <li>
                  <strong>Đối tác kinh doanh:</strong> Các đối tác tin cậy hỗ
                  trợ chúng tôi trong việc cung cấp dịch vụ hoặc tiếp thị.
                </li>
                <li>
                  <strong>Cơ quan quản lý và thực thi pháp luật:</strong> Khi
                  cần thiết theo yêu cầu pháp lý hoặc để bảo vệ quyền lợi của
                  chúng tôi.
                </li>
                <li>
                  <strong>Trong trường hợp mua bán, sáp nhập:</strong> Nếu doanh
                  nghiệp của chúng tôi tham gia vào giao dịch mua bán hoặc sáp
                  nhập.
                </li>
              </ul>
              <p className="mt-4">
                <strong>Lưu ý:</strong> Chúng tôi yêu cầu tất cả các bên thứ ba
                tôn trọng tính bảo mật của dữ liệu và xử lý theo cách phù hợp
                với chính sách của chúng tôi.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              6. Thời gian lưu trữ dữ liệu
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                Chúng tôi chỉ lưu trữ thông tin cá nhân của bạn trong thời gian
                cần thiết để đạt được mục đích thu thập, tuân thủ các nghĩa vụ
                pháp lý, giải quyết tranh chấp và thực thi các thỏa thuận của
                chúng tôi.
              </p>
              <p>
                <strong>Dữ liệu tài khoản:</strong> Được lưu trữ trong suốt thời
                gian tài khoản của bạn còn hoạt động và có thể lưu trữ thêm đến
                12 tháng sau khi bạn đóng tài khoản để phục vụ mục đích pháp lý.
              </p>
              <p>
                <strong>Dữ liệu thanh toán:</strong> Được lưu trữ theo yêu cầu
                của luật kế toán và thuế, thường là 7-10 năm.
              </p>
              <p>
                <strong>Dữ liệu sử dụng và phân tích:</strong> Có thể được lưu
                trữ lên đến 25 tháng để phân tích xu hướng và cải thiện dịch vụ.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              7. Bảo mật thông tin
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                Chúng tôi áp dụng các biện pháp bảo mật kỹ thuật và tổ chức mạnh
                mẽ để bảo vệ thông tin của bạn:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Mã hóa dữ liệu trong quá trình truyền và lưu trữ</li>
                <li>Kiểm soát truy cập chặt chẽ với nhân viên</li>
                <li>Giám sát hệ thống 24/7</li>
                <li>Đánh giá rủi ro bảo mật định kỳ</li>
                <li>Tuân thủ các tiêu chuẩn bảo mật ngành</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              8. Quyền của người dùng
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>Bạn có các quyền sau đối với thông tin cá nhân của mình:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Quyền truy cập và xem thông tin</li>
                <li>Quyền chỉnh sửa thông tin không chính xác</li>
                <li>Quyền xóa thông tin trong một số trường hợp</li>
                <li>Quyền hạn chế xử lý thông tin</li>
                <li>Quyền phản đối việc xử lý thông tin</li>
                <li>Quyền di chuyển dữ liệu</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              9. Quy trình giải quyết khiếu nại
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                Nếu bạn có khiếu nại về cách chúng tôi xử lý thông tin cá nhân
                của bạn, vui lòng liên hệ với Nhân viên Bảo vệ Dữ liệu của chúng
                tôi qua email privacy@aiprice.vn. Chúng tôi sẽ phản hồi khiếu
                nại của bạn trong vòng 30 ngày.
              </p>
              <p>Quy trình giải quyết khiếu nại của chúng tôi bao gồm:</p>
              <ol className="list-decimal pl-6 space-y-2">
                <li>Tiếp nhận và ghi nhận khiếu nại</li>
                <li>Điều tra và đánh giá khiếu nại</li>
                <li>Phản hồi và đề xuất giải pháp</li>
                <li>Thực hiện các biện pháp khắc phục cần thiết</li>
              </ol>
              <p className="mt-4">
                Nếu bạn không hài lòng với cách chúng tôi giải quyết khiếu nại,
                bạn có quyền liên hệ với cơ quan bảo vệ dữ liệu có thẩm quyền.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              10. Cập nhật chính sách
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                Chúng tôi có thể cập nhật Chính sách Quyền riêng tư này tùy từng
                thời điểm để phản ánh thay đổi trong thực tiễn xử lý thông tin
                của chúng tôi hoặc vì lý do pháp lý, hoạt động và thương mại
                khác.
              </p>
              <p>
                Khi có thay đổi đáng kể, chúng tôi sẽ thông báo cho bạn thông
                qua email hoặc thông báo nổi bật trên dịch vụ của chúng tôi ít
                nhất 30 ngày trước khi thay đổi có hiệu lực.
              </p>
              <p>
                Chúng tôi khuyến khích bạn xem xét định kỳ chính sách này để
                được cập nhật về cách chúng tôi bảo vệ thông tin của bạn.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              11. Miễn trừ trách nhiệm về nội dung AI
            </h2>
            <div className="text-gray-600 space-y-4 bg-yellow-100 border-l-4 border-yellow-500 p-4 rounded">
              <p className="font-semibold">Lưu ý quan trọng:</p>
              <p>
                Dịch vụ AIPrice sử dụng công nghệ trí tuệ nhân tạo (AI) để định
                giá bất động sản và tạo nội dung. Công nghệ này đang trong quá
                trình phát triển và đôi khi có thể tạo ra kết quả định giá không
                chính xác, không đầy đủ, gây hiểu lầm hoặc thậm chí sai lệch,
                không phản ánh thực tế thị trường của AIPrice.
              </p>
              <p>
                <strong>
                  Người dùng phải xem xét, đánh giá cẩn thận và chịu hoàn toàn
                  trách nhiệm
                </strong>{" "}
                đối với bất kỳ nội dung nào được tạo ra bởi Dịch vụ trước khi
                đăng tải, xuất bản hoặc sử dụng cho bất kỳ mục đích nào, đặc
                biệt là trên các nền tảng mạng xã hội, website hoặc các kênh
                truyền thông khác.
              </p>
              <p>
                <strong>
                  Không dựa vào nội dung AI để được tư vấn chuyên môn:
                </strong>{" "}
                Nội dung do AI tạo ra chỉ nhằm mục đích thông tin chung và tham
                khảo. Nó không thể thay thế cho lời khuyên từ các chuyên gia có
                trình độ trong các lĩnh vực như y tế, pháp lý, tài chính, v.v.
                Bất kỳ nội dung nào liên quan đến các chủ đề này đều không được
                coi là lời khuyên chuyên nghiệp, chẩn đoán hay phương pháp điều
                trị.
              </p>
              <p>
                AIPrice không chịu trách nhiệm pháp lý cho bất kỳ hậu quả nào
                phát sinh từ việc người dùng tin tưởng, xuất bản hoặc sử dụng
                kết quả định giá và nội dung do AI cung cấp mà không có sự kiểm
                duyệt và xác minh độc lập.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              12. Thông tin liên hệ
            </h2>
            <div className="text-gray-600">
              <p className="mb-4">
                Nếu bạn có bất kỳ câu hỏi nào về Chính sách Quyền riêng tư này,
                vui lòng liên hệ với chúng tôi:
              </p>
              <ul className="space-y-2">
                <li>
                  <strong>Email:</strong> contact@youhomes.vn
                </li>
                <li>
                  <strong>Điện thoại:</strong> 0886399781
                </li>
                <li>
                  <strong>Địa chỉ:</strong> tòa Hồ Gươm Plaza, số 102 Trần Phú,
                  Hà Đông, Hà Nội
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PolicyScreen;
